import { render } from "./Footer.vue?vue&type=template&id=335eb522&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=335eb522&scoped=true&lang=css"

import exportComponent from "/Volumes/LACIE/vueSites/yem/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-335eb522"]])

export default __exports__